<template>
  <!--栏目列表 -->
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text primaryCol">栏目列表</div>
        <el-button
          class="butSmallH"
          @click="addColumnBut"
          type="primary"
          size="small"
          >添加栏目</el-button
        >
      </div>

      <el-table
        height="80vh"
        row-key="id"
        :data="navigationList"
        :tree-props="{ children: 'list' }"
        default-expand-all
        style="width: 100%"
        stripe
      >
        <el-table-column label="ID" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | FilterDataTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="栏目名"> </el-table-column>
        <el-table-column prop="url" label="栏目路径"> </el-table-column>
        <el-table-column label="栏目等级">
          <template slot-scope="scope">
            <span>{{
              scope.row.lv | FilterNumber('一级栏目', '二级栏目')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-popover
              placement="top"
              width="180"
              class="padHorizontal10"
              :ref="`popover-${scope.$index}`"
            >
              <p>这是一段内容这是一段内容确定删除吗？</p>
              <div style="text-align: right; margin: 0">
                <el-button
                  size="mini"
                  type="text"
                  @click="
                    scope._self.$refs[`popover-${scope.$index}`].doClose()
                  "
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    cancelClick(
                      scope.row,
                      scope._self.$refs[`popover-${scope.$index}`].doClose()
                    )
                  "
                  >确定</el-button
                >
              </div>
              <el-button slot="reference" type="text" size="small"
                >删除</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// 导入我们的api接口
import {
  apiNavigationFindAll,
  apiRemoveNavigation
} from '@/api/backgroundViews'

export default {
  name: '',
  props: [''],
  data() {
    return {
      tableData: [{}, {}],

      Userform: {
        name: '',
        sex: '',
        tel: '',
        password: ''
      },
      navigationList: [], // 导航列表
      cancelVisible: false // 删除弹出框
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.NavigationFindAll()
  },

  methods: {
    // 添加栏目
    addColumnBut() {
      this.$router.push({
        path: '/addColumn'
      })
    },
    // 列表编辑
    editClick(row) {
      this.$router.push({
        path: '/addColumn',
        query: {
          id: row.id,
          name: row.name,
          lv: row.lv,
          url: row.url,
          parentId: row.parentId
        }
      })
    },
    // 列表删除
    cancelClick(row) {
      apiRemoveNavigation({
        id: row.id
      }).then(res => {
        if (res.status === '0') {
          this.$Ms(res.msg)
          this.NavigationFindAll()
        } else if (res.status === '1') {
          this.$Me(res.msg)
        }
      })
    },
    /*
     *接口
     */
    // 查询全部导航栏
    NavigationFindAll() {
      apiNavigationFindAll().then(res => {
        if (res.status === '0') {
          this.navigationList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
$padding: 10px;
$colorMajor: #005ca1;
.vue {
  text-align: left;
  background-color: #fff;
  padding: $padding;
  .header {
    border-bottom: 1px solid #f3f3f3;
    justify-content: space-between;
    .text {
      text-align: left;
      padding: 10px 5px;
    }
  }
  .but {
    padding-bottom: $padding - 2px;
  }
}
</style>
